<template>
    <div class="box">
      <img class="logo-error" src="@/assets/images/logo-active-progress.png" alt />
      <p class="lds-text">Tracking not found</p>
      <p class="lds-text lds-text--2nd">UPS. To chyba niekompletny adres.</p>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped lang="scss">
.logo-error {
    position: absolute;
    top: calc(45% - 70px);
    left: calc(50% - 70px);
    width: 140px;
    z-index: 999999;
}
.lds-text {
    position: absolute;
    left: calc(50% - 80px);
    top: calc(50% - 40px);
    display: inline-block;
    margin: auto;
    min-width: 40px;
    font-size: 16px;
    font-weight: 700;
    z-index: 999999;

    &--2nd {
      top: 50%;
    }
}
</style>